import React, { useEffect, useState } from 'react'
import { useIsMobile } from '../../../hooks/breakpoints'

const Stepper = ({ steps, currentStep, handleBack }) => {
  const [stepState, setStepState] = useState([])
  const isMobile = useIsMobile();

  const styles = {
    stepperWrapper: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      width: '100%',
      marginBottom: '1.875rem',
      lineHeight: '19px',
      fontFamily: 'JioType-Medium',
    },
    stepperWrapperMobile: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      width: '100vw',
      marginBottom: '1rem',
      lineHeight: '19px',
      fontFamily: 'JioType-Medium',
    },
    stepWrapper: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative'
    },
    stepperActive: {
      transform: 'rotate(-90deg)',
      marginLeft: '0.5rem',
      marginRight: '0.5rem'
    },
    stepperDisable: {
      transform: 'rotate(-90deg)',
      marginLeft: '0.5rem',
      marginRight: '0.5rem'
    },
    dividerLine: {
      height: '1px',
      backgroundColor: '#bdbdbd',
      position: 'absolute',
      top: '12px',
      left: 'calc(50% + 20px)',
      right: 'calc(-50% + 20px)'
    },
    description: {
      fontSize: '16px',
      textAlign: 'center',
      color: '#333333'
    },
    descriptionDisable: {
      fontSize: '16px',
      textAlign: 'center',
      color: '#0000008A'
    },
    descriptionMobile: {
      fontSize: '10px',
      textAlign: 'center',
      color: '#333333'

    },
    descriptionDisableMobile: {
      fontSize: '10px',
      textAlign: 'center',
      color: '#0000008A'
    }

  }

  useEffect(() => {
    let createSteps = steps.map((step, idx) => ({
      description: step,
      completed: idx < currentStep, // past are completed
      selected: idx <= currentStep, // past & present are colored
      highlighted: idx === currentStep, // only present is highlighted
      key: idx
    }))
    setStepState(createSteps)
  }, [steps, currentStep])

  return (
    <div style={isMobile ? styles.stepperWrapperMobile : styles.stepperWrapper}>
      {currentStep > 0 && <img src='/icons/back-arrow.svg' style={isMobile ? { height: '25px', width: '25px', cursor: 'pointer' } : { marginRight: '12px', cursor: 'pointer' }} alt='back arrow' onClick={handleBack} />}
      {
        stepState.map(({ selected, completed, description, key }, idx) => (<div key={key} id={key}>
          <div style={styles.stepWrapper}>
            <div style={selected ?
              (isMobile ? styles.descriptionMobile : styles.description)
              : (isMobile ? styles.descriptionDisableMobile : styles.descriptionDisable)}>
              {description}
            </div>
            <div>
              <img src={selected ? '/icons/arrow-ios-downward-fill.svg' : '/icons/arrow-ios-downward-fill-grey.svg'} style={selected ? styles.stepperActive : styles.stepperDisable} alt='' />
            </div>
          </div>
        </div>
        ))
      }
    </div >
  )
}

export default Stepper
